module.exports = __webpack_public_path__ + "img/GH.b4b7f515.svg";